export default "__VITE_ASSET__$IN7HDQa__"